import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ProtectedRoute from "./helpers/PrivateRoute";
import PublicRoute from "./helpers/PublicRoute";
import { IsNullOrEmpty } from "./helpers/utility";
import AccountPreferences from "./pages/AccountPreferences/AccountPreferences";
import Address from "./pages/AccountPreferences/Address";
import Password from "./pages/AccountPreferences/Password";
import Payment from "./pages/AccountPreferences/Payment";
import Plan from "./pages/AccountPreferences/Plan";
import PrivacySettings from "./pages/AccountPreferences/PrivacySettings";
import Profile from "./pages/AccountPreferences/Profile";
import Withdrawal from "./pages/AccountPreferences/Withdrawal";
import WithdrawBalance from "./pages/AccountPreferences/WithdrawBalance";
import Authentication from "./pages/Authentication/authentication";
import ForgotPassword from "./pages/Authentication/forgot_password";
import UserGuestInfo from "./pages/Authentication/info";
import Login from "./pages/Authentication/login";
import SignUp from "./pages/Authentication/signup";
import Cart from "./pages/Cart/Cart";
import Checkout from "./pages/Cart/Checkout";
import InstantCart from "./pages/Cart/InstantCart";
import OrderCompleted from "./pages/Cart/OrderCompleted";
import Chat from "./pages/Chat/Chat";
import AllEarnings from "./pages/Dashboard/AllEarnings";
import AllSpendings from "./pages/Dashboard/AllSpendings";
import Dashboard from "./pages/Dashboard/Dashboard";
import Email from "./pages/Emails/Email";
import Home from "./pages/Home/Home";
import InviteFriends from "./pages/Home/InviteFriends";
import SuccessfullyUpgraded from "./pages/Home/SuccessfullyUpgraded";
import UpgradePlan from "./pages/Home/UpgradePlan";
import YoutubeVideos from "./pages/Home/YoutubeVideos";
import LivestreamAnonymous from "./pages/Landing/livestreamAnonymous";
import CreateVipCircle from "./pages/livestream/create_vip_circle";
import InstantVideo from "./pages/livestream/instant_video";
import SelectVIPCircle from "./pages/livestream/select_vip_circle";
import SetupMeeting from "./pages/livestream/setup_meeting";
import ManageOrder from "./pages/ManageOrder/ManageOrder";
import LiveStream from "./pages/Marketplace/Livestream/LiveStreaming";
import LiveStreams from "./pages/Marketplace/LiveStreams";
import Marketplace from "./pages/Marketplace/Marketplace";
import PreviewAudience from "./pages/Marketplace/Preview/Audience";
import PreviewInfo from "./pages/Marketplace/Preview/Info";
import PreviewLive from "./pages/Marketplace/Preview/PreviewLive";
import PreviewProduct from "./pages/Marketplace/Preview/Product";
import PreviewSchedule from "./pages/Marketplace/Preview/Schedule";
import { CalendlyOauth } from "./pages/livestream/edit_video/calendlyOauth";
import Audience from "./pages/Marketplace/ReplayChat/Audience";
import Info from "./pages/Marketplace/ReplayChat/Info";
import Product from "./pages/Marketplace/ReplayChat/Product";
import Replay from "./pages/Marketplace/ReplayChat/Replay";
import ReplayChat from "./pages/Marketplace/ReplayChat/ReplayChat";
import MyStore from "./pages/MyStore/MyStore";
import ViewStore from "./pages/MyStore/ViewStore";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import AllNotifications from "./pages/Notification/AllNotifications";
import Notification from "./pages/Notification/Notification";
import OtherMeetingRoom from "./pages/OtherProfile/MeetingRoom";
import OtherRecordings from "./pages/OtherProfile/MyRecordings";
import OtherPrivateLounge from "./pages/OtherProfile/PrivateLounge";
import OtherPublicHall from "./pages/OtherProfile/PublicHall";
import MyShop from "./pages/OtherProfile/shop";
import ViewOtherProfile from "./pages/OtherProfile/ViewProfile";
import OtherVIPCircle from "./pages/OtherProfile/VipCircle";
import MeetingRoom from "./pages/Profile/MeetingRoom";
import MyRecordings from "./pages/Profile/MyRecordings";
import PrivateLounge from "./pages/Profile/PrivateLounge";
import ChooseProfile from "./pages/Profile/Profile";
import ProfileList from "./pages/Profile/profiles_list";
import PublicHall from "./pages/Profile/PublicHall";
import ViewProfile from "./pages/Profile/ViewProfile";
import VipCircle from "./pages/Profile/VipCircle";
import SearchResult from "./pages/SearchResult/SearchResult";
import Starred from "./pages/Starred/Starred";
import MySubscription from "./pages/Subscription/MySubscription/MySubscription";
import SubsPrivateLounge from "./pages/Subscription/MySubscription/SubsPrivateLounge";
import SubsVipCrcle from "./pages/Subscription/MySubscription/SubsVipCrcle";
import SetPrivateLounge from "./pages/Subscription/SetSubscription/SetPrivateLounge";
import SetSubscription from "./pages/Subscription/SetSubscription/SetSubscription";
import SetVipCrcle from "./pages/Subscription/SetSubscription/SetVipCrcle";
import SubscriptionPayment from "./pages/Subscription/subscription_payment";
import VIPSubscriptionPayment from "./pages/Subscription/vip_subscription_payment";
import UpdateLiveStream from "./pages/livestream/update_livestream";
import { StripeOauth } from "./pages/livestream/edit_video/stripeOauth";

function App() {
    const location = useLocation();
    let accessToken = sessionStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);
    useEffect(() => {
        if (location.hash.indexOf("#embed") === -1 
        && location.pathname.indexOf("/video") === -1
        && location.pathname.indexOf("/page/livestream/update") === -1) {
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "k77cvpin",
            });
        }
    }, [location]);
    return (
        <div>
            <Routes>
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/signup" element={<SignUp />} />
                <Route
                    exact
                    path="/calendly/auth"
                    element={
                        <PublicRoute>
                            <CalendlyOauth />
                        </PublicRoute>
                    }
                />
                   <Route
                    exact
                    path="/stripe/auth"
                    element={
                        <PublicRoute>
                            <StripeOauth />
                        </PublicRoute>
                    }
                />
                <Route
                    exact
                    path="/:id"
                    element={
                        !IsNullOrEmpty(accessToken) ? (
                            <ProtectedRoute>
                                <ChooseProfile />
                            </ProtectedRoute>
                        ) : (
                            <PublicRoute>
                                <UserGuestInfo />
                            </PublicRoute>
                        )
                    }
                />
                <Route
                    exact
                    path="/authentication"
                    element={
                        <PublicRoute>
                            <Authentication />
                        </PublicRoute>
                    }
                />
                <Route
                    exact
                    path="/forgot-password"
                    element={
                        <PublicRoute>
                            <ForgotPassword />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/video/:id"
                    element={
                        <PublicRoute>
                            <LivestreamAnonymous />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Home />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/marketplace"
                    element={
                        <ProtectedRoute>
                            <Marketplace />
                        </ProtectedRoute>
                    }
                >
                    <Route
                        index
                        element={
                            <ProtectedRoute>
                                <LiveStreams />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/page/marketplace/liveStreams"
                        element={
                            <ProtectedRoute>
                                <LiveStreams />
                            </ProtectedRoute>
                        }
                    />
                    {/* <Route
                        path="/page/marketplace/products"
                        element={
                            <ProtectedRoute>
                                <Products />
                            </ProtectedRoute>
                        }
                    /> */}
                </Route>
                <Route
                    path="/page/dashboard"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/dashboard/spendings"
                    element={
                        <ProtectedRoute>
                            <AllSpendings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/dashboard/earnings"
                    element={
                        <ProtectedRoute>
                            <AllEarnings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/favorites"
                    element={
                        <ProtectedRoute>
                            <Starred />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/cart"
                    element={
                        <ProtectedRoute>
                            <Cart />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Checkout />} />
                    <Route path="/page/cart/checkout" element={<Checkout />} />
                </Route>
                <Route
                    path="/page/orderComplete"
                    element={
                        <ProtectedRoute>
                            <OrderCompleted />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/checkout"
                    element={
                        <ProtectedRoute>
                            <InstantCart />
                        </ProtectedRoute>
                    }
                ></Route>
                <Route
                    path="/page/order"
                    element={
                        <ProtectedRoute>
                            <ManageOrder />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/subscription"
                    element={
                        <ProtectedRoute>
                            <MySubscription />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<SubsPrivateLounge />} />
                    <Route
                        path="/page/subscription/private-lounge"
                        element={<SubsPrivateLounge />}
                    />
                    <Route
                        path="/page/subscription/vip-circle"
                        element={<SubsVipCrcle />}
                    />
                </Route>
                <Route
                    path="/page/manage-subscription"
                    element={
                        <ProtectedRoute>
                            <SetSubscription />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<SetPrivateLounge />} />
                    <Route
                        path="/page/manage-subscription/private-lounge"
                        element={<SetPrivateLounge />}
                    />
                    <Route
                        path="/page/manage-subscription/vip-circle"
                        element={<SetVipCrcle />}
                    />
                </Route>
                <Route
                    path="/page/vip-subscription-payment"
                    element={
                        <ProtectedRoute>
                            <VIPSubscriptionPayment />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/subscription_payment"
                    element={
                        <ProtectedRoute>
                            <SubscriptionPayment />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/store"
                    element={
                        <ProtectedRoute>
                            <MyStore />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/profile/list"
                    element={
                        <ProtectedRoute>
                            <ProfileList />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/viewStore"
                    element={
                        <ProtectedRoute>
                            <ViewStore />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/start-new-video"
                    element={
                        <ProtectedRoute>
                            <SetupMeeting />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/create_vip_circle"
                    element={
                        <ProtectedRoute>
                            <CreateVipCircle />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/instant_video"
                    element={
                        <ProtectedRoute>
                            <InstantVideo />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/select-vip-circle"
                    element={
                        <ProtectedRoute>
                            <SelectVIPCircle />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/livestream/update"
                    element={
                        <ProtectedRoute>
                            <UpdateLiveStream />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/livestream"
                    element={
                        <ProtectedRoute>
                            <LiveStream />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<PreviewInfo />} />
                    <Route
                        path="/page/livestream/info"
                        element={<PreviewInfo />}
                    />
                    <Route
                        path="/page/livestream/product"
                        element={<PreviewProduct />}
                    />
                    <Route
                        path="/page/livestream/audience"
                        element={<PreviewAudience />}
                    />
                    <Route
                        path="/page/livestream/schedule"
                        element={<PreviewSchedule />}
                    />
                </Route>
                <Route
                    path="/page/preview"
                    element={
                        <ProtectedRoute>
                            <PreviewLive />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<PreviewInfo />} />
                    <Route
                        path="/page/preview/info"
                        element={<PreviewInfo />}
                    />
                    <Route
                        path="/page/preview/product"
                        element={<PreviewProduct />}
                    />
                    <Route
                        path="/page/preview/audience"
                        element={<PreviewAudience />}
                    />
                    <Route
                        path="/page/preview/schedule"
                        element={<PreviewSchedule />}
                    />
                </Route>
                <Route
                    path="/page/replay"
                    element={
                        <ProtectedRoute>
                            <Replay />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<ReplayChat />} />
                    <Route
                        path="/page/replay/replayChat"
                        element={<ReplayChat />}
                    />
                    <Route path="/page/replay/info" element={<Info />} />
                    <Route path="/page/replay/product" element={<Product />} />
                    <Route
                        path="/page/replay/audience"
                        element={<Audience />}
                    />
                </Route>
                <Route
                    path="/page/youtubeVideos"
                    element={
                        <ProtectedRoute>
                            <YoutubeVideos />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/chat"
                    element={
                        <ProtectedRoute>
                            <Chat />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/notification"
                    element={
                        <ProtectedRoute>
                            <Notification />
                        </ProtectedRoute>
                    }
                >
                    <Route
                        index
                        element={
                            <ProtectedRoute>
                                <AllNotifications />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/page/notification/allNotifications"
                        element={
                            <ProtectedRoute>
                                <AllNotifications />
                            </ProtectedRoute>
                        }
                    />
                </Route>

                <Route
                    path="/page/inbox/"
                    element={
                        <ProtectedRoute>
                            <Email />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/page/refer"
                    element={
                        <ProtectedRoute>
                            <InviteFriends />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/search"
                    element={
                        <ProtectedRoute>
                            <SearchResult />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/upgradePlan"
                    element={
                        <ProtectedRoute>
                            <UpgradePlan />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/successfullyUpgraded"
                    element={
                        <ProtectedRoute>
                            <SuccessfullyUpgraded />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/:id/profile"
                    element={
                        <ProtectedRoute>
                            <ViewOtherProfile />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<OtherPublicHall />} />
                    <Route
                        path="/:id/profile/public-hall"
                        element={<OtherPublicHall />}
                    />
                    <Route
                        path="/:id/profile/private-lounge"
                        element={<OtherPrivateLounge />}
                    />
                    <Route
                        path="/:id/profile/meeting-room"
                        element={<OtherMeetingRoom />}
                    />
                    <Route
                        path="/:id/profile/vip-circle"
                        element={<OtherVIPCircle />}
                    />
                    <Route
                        path="/:id/profile/recordings"
                        element={<OtherRecordings />}
                    />
                </Route>
                <Route
                    path="/:id/profile/shop"
                    element={
                        <ProtectedRoute>
                            <MyShop />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/page/profile"
                    element={
                        <ProtectedRoute>
                            <ViewProfile />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<PublicHall />} />
                    <Route
                        path="/page/profile/public-hall"
                        element={<PublicHall />}
                    />
                    <Route
                        path="/page/profile/private-lounge"
                        element={<PrivateLounge />}
                    />
                    <Route
                        path="/page/profile/meeting-room"
                        element={<MeetingRoom />}
                    />
                    <Route
                        path="/page/profile/vip-circle"
                        element={<VipCircle />}
                    />
                    <Route
                        path="/page/profile/recordings"
                        element={<MyRecordings />}
                    />
                </Route>
                <Route
                    path="/page/account"
                    element={
                        <ProtectedRoute>
                            <AccountPreferences />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Profile />} />
                    <Route path="/page/account/profile" element={<Profile />} />
                    <Route
                        path="/page/account/password"
                        element={<Password />}
                    />
                    <Route path="/page/account/address" element={<Address />} />
                    <Route path="/page/account/payment" element={<Payment />} />
                    <Route
                        path="/page/account/withdrawal"
                        element={<Withdrawal />}
                    />
                    <Route
                        path="/page/account/withdraw-balance"
                        element={<WithdrawBalance />}
                    />
                    <Route
                        path="/page/account/privacySettings"
                        element={<PrivacySettings />}
                    />
                    <Route path="/page/account/plan" element={<Plan />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </div>
    );
}

export default App;
